import { ModalContext } from "app/app";
import axios from "axios";
import { FieldInput } from "components/fieldInput";
import { ViewContext } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function EditDocumentModal(props) {
  const context = useContext(ViewContext);
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const options = [
    {
      value: "active",
      label: "Active",
    },
    {
      value: "pending_review",
      label: "Pending Review",
    },
    {
      value: "denied",
      label: "Denied",
    },
    {
      value: "expired",
      label: "Expired",
    },
  ];

  return (
    <Fragment>
      {modal.name === "edit_document_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Edit Document</div>
              <div className={styles.line} />
              <Formik
                initialValues={{
                  status: modal.data.status
                    ? modal.data.status
                    : options[0].value,
                }}
                onSubmit={async (values) => {
                  const { status } = values;

                  await axios
                    .patch(`/api/document/${modal.data.id}`, {
                      status,
                    })
                    .then(async (res) => {
                      modal.action();

                      context.notification.show(
                        "Document updated",
                        "success",
                        true,
                        "toast",
                        "check-circle"
                      );
                    })
                    .catch((err) => {
                      setLoading(false);
                      setModal({});

                      context.notification.show(
                        err.response.data.message,
                        "error",
                        true,
                        "toast",
                        "x-circle"
                      );
                    });

                  setLoading(false);
                  setModal({});
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div
                        className={styles.fieldRow}
                        style={{ paddingBottom: 0 }}
                      >
                        <FieldInput
                          id="status"
                          type="select"
                          label="Status"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          required
                          options={options}
                          showErrors
                          errors={errors.status}
                          touched={touched.status}
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={{ justifyContent: "flex-end" }}
                    >
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button
                          className={styles.save}
                          onClick={!loading ? submitForm : null}
                          style={
                            !loading
                              ? { cursor: "pointer" }
                              : { cursor: "default" }
                          }
                        >
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            <>Update</>
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
